const YOTPO_APP_KEY = process.env.GATSBY_YOTPO_APP_KEY;
export const fetchProductReviews = async (
  productId,
  page,
  stars,
  perPage = 10
) => {
  const options = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };
  if (stars) {
    const response = await fetch(
      `https://api-cdn.yotpo.com/v1/widget/${YOTPO_APP_KEY}/products/${productId}/reviews.json?per_page=${perPage}&page=${page}&star=${stars}&sort=date&direction=desc`,
      options
    );
    const data = await response.json();
    return {
      totalReview: data.response.pagination.total,
      averageScore: data.response.bottomline.average_score,
      reviews: data.response.reviews,
    };
  }
  const response = await fetch(
    `https://api-cdn.yotpo.com/v1/widget/${YOTPO_APP_KEY}/products/${productId}/reviews.json?per_page=${perPage}&page=${page}&sort=date&direction=desc`,
    options
  );
  const data = await response.json();
  return {
    totalReview: data.response.bottomline.total_review,
    averageScore: data.response.bottomline.average_score,
    reviews: data.response.reviews,
  };
};
